import React from 'react'

const Logo = () => {
  return (
    <div className="logo">
      <img src='/media/logoIconWhite.svg' height="50px" alt="Icon Logo of RaicesLocales in White Format (SVG)" />
    </div>
  )
}

export default Logo
